import Nav from './components/Nav';
import Footer from './components/Footer';
import MainContent from './components/MainContent';

function App() {
  return (
    <div className="App">
      <Nav/>  
      <MainContent/> 
      <Footer/>      
    </div>
  );
}

export default App;
